(() => {
	angular.module('main').directive('tableRowLink', tableRowLink);

	tableRowLink.$inject = ['$interval', '$rootScope', '$timeout'];

	function tableRowLink($interval, $rootScope, $timeout) {
		return {
			restrict: 'A',
			scope: {
				tableRowLinkHref: '@',
				tableRowLinkId: '@',
				itemsList: '='
			},
			link(scope, element) {
				const table = jQuery(element[0]).find('table');
				const tbody = table.find('tbody');

				const intervalRootScopeId = scope.tableRowLinkId
					? `intervalPromise-${scope.tableRowLinkId}`
					: 'intervalPromise';

				scope.$watchCollection('itemsList', (newVal, oldVal) => {
					if ($rootScope[intervalRootScopeId]) {
						element.removeClass('table-row-link');
						$interval.cancel($rootScope[intervalRootScopeId]);
						$('.table-row-link__link').remove();
						startTableRandering();
					} else {
						$('.table-row-link__link').remove();
						startTableRandering();
					}
				});

				function startTableRandering() {
					$rootScope[intervalRootScopeId] = $interval(() => {
						if (table.find('.lastTableRow').length) {
							$interval.cancel($rootScope[intervalRootScopeId]);
							initDirective();
						}
					}, 100);
				}

				function initDirective() {
					initLinks(table);

					jQuery(window).on('resize', () => {
						initLinks(table);
					});

					scope.$on('$destroy', () => {
						jQuery(window).off('resize');
					});
				}

				function updateLinkStyle(linkEl, linkStyle) {
					linkEl.css(linkStyle);
				}

				function getLinkStyles(currentEl, parentEl) {
					const height = currentEl.height();
					const width = currentEl.width();

					const top = currentEl.offset().top - parentEl.offset().top;
					const left = 0;

					return {
						height,
						width,
						top,
						left
					};
				}

				function initLinks(table) {
					element.addClass('table-row-link');

					const tableRow = table.find('tbody tr');

					tableRow.each((i, el) => {
						const dataLinkId = jQuery(el).attr('data-link-id');

						if (jQuery(element[0]).find(`.table-row-link__link${i}`).length) {
							const link = jQuery(element[0]).find(`.table-row-link__link${i}`);

							const styles = getLinkStyles(jQuery(el), jQuery(element[0]));

							updateLinkStyle(link, styles);
						} else {
							const styles = getLinkStyles(jQuery(el), jQuery(element[0]));

							const link = jQuery(
								`<a data-link-id="${dataLinkId}" href="${
									scope.tableRowLinkHref
								}${dataLinkId}" class="table-row-link__link table-row-link__link${i}"></a>`
							);

							jQuery(el).on('mousedown', e => {
								if (e.which === 3) {
									link.addClass('active');

									$timeout(() => {
										link.removeClass('active');
									}, 100);
								}
							});

							jQuery(element[0]).append(link);

							updateLinkStyle(link, styles);
						}
					});
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/tableRowLink.js